import { ColDef } from "ag-grid-community";
import { HierarchyAllItemsVisibilityCellRenderer } from "@/components/pages/common/hierarchy-all-items/components/cell-renderers/HierarchyAllItemsVisibilityCellRenderer";
import { hierarchyAllItemsVisibilityValueGetter } from "@/components/pages/common/hierarchy-all-items/utils/helpers/valueGetters";
import { HierarchyFolderItem } from "@/store/navigation/utils/types";
import { modifiedByColumnDef } from "@/components/pages/common/ag-grid/components/columns/modifiedByColumnDef";
import { HierarchyAllItemsModifiedByCellRenderer } from "@/components/pages/common/hierarchy-all-items/components/cell-renderers/HierarchyAllItemsModifiedByCellRenderer";
import { createdByColumnDef } from "@/components/pages/common/ag-grid/components/columns/createdByColumnDef";
import { HierarchyAllItemsCreatedByCellRenderer } from "@/components/pages/common/hierarchy-all-items/components/cell-renderers/HierarchyAllItemsCreatedByCellRenderer";
import { agGridEmptyColumnToFitEmptySpace } from "@/components/pages/common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";

export const hierarchyAllItemsColDef: ColDef<HierarchyFolderItem>[] = [
  {
    field: "visibility",
    headerName: "Visibility",
    minWidth: 175,
    cellRenderer: HierarchyAllItemsVisibilityCellRenderer,
    valueGetter: hierarchyAllItemsVisibilityValueGetter,
  },

  {
    ...modifiedByColumnDef,
    maxWidth: 450,
    minWidth: 175,
    cellRenderer: HierarchyAllItemsModifiedByCellRenderer,
  } as ColDef,
  {
    ...createdByColumnDef,
    maxWidth: 450,
    minWidth: 175,
    cellRenderer: HierarchyAllItemsCreatedByCellRenderer,
  } as ColDef,

  agGridEmptyColumnToFitEmptySpace,
];
